import { ReferenceField, TextField } from "react-admin";
import * as React from "react";
import { SourceVwUser } from "../../../Constants/Source";
import PropTypes from "prop-types";

const CreatedByField = ({ source = "createdBy", record, label, link, variant }) => {
  let crBy: number = Number(record[source]);
  let isNan: boolean = isNaN(crBy);
  return isNan ? (
    <TextField source={source} record={record} label={label} variant={variant as any} />
  ) : (
    <ReferenceField label={label} source={source} reference={SourceVwUser} record={record} link={link}>
      <TextField source="name" variant={variant as any} />
    </ReferenceField>
  );
};

CreatedByField.propTypes = {
  variant: PropTypes.any,
  record: PropTypes.any,
  label: PropTypes.string,
  link: PropTypes.bool,
  source: PropTypes.string,
};

export default CreatedByField;
